window.serviceBookingModal = window.serviceBookingModal || {};
window.serviceBookingModal.open = function (servicePackage) {
    const inNeosBackend = window.name === 'neos-content-main';
    if (inNeosBackend) {
        alert('Das Buchungsformular kann nicht im Redaktionssystem-Backend geöffnet werden.');
        return;
    }

    if (window.serviceBookingModal.reactIsInitialized) {
        window.dispatchEvent(new CustomEvent('service-booking:open', { detail: servicePackage }));
        return;
    }

    // store for React to find
    window.serviceBookingModal.pendingOpen = servicePackage;

    const scriptExists = !!document.getElementById('service-booking-script');
    if (scriptExists) {
        // if the script is already added, it init in less than 1 second
        setTimeout(() => {
            if (window.serviceBookingModal.pendingOpen) {
                alert('Das Buchungsformular kann nicht geladen werden.');
            }
        }, 1000);
        return;
    }

    // load React script
    const newScript = document.createElement('script');
    newScript.src = document.body.dataset.serviceBookingScriptUrl;
    newScript.id = 'service-booking-script';
    newScript.async = true;
    document.head.appendChild(newScript);
};

// if the function was already called, before we initialized,
// open the modal
if (window.serviceBookingModal.pendingOpen) {
    window.openServiceBookingModal(window.serviceBookingModal.pendingOpen);
    delete window.serviceBookingModal.pendingOpen;
}
